module.exports = __webpack_public_path__ + "img/marker-border.26c3556f.svg";